import client from './client';

export const getCreditBalance = () => client.get('/ai/credits/balance').then(res => res.data);

export const getCreditPrices = () => client.get('/ai/credits/prices').then(res => res.data);

export const checkoutCredits = (credits: number, provider: 'stripe' | 'bank' = 'bank') =>
  client.post('/ai/credits/checkout', { credits, provider }).then(res => res.data);

export const getAITasks = (status?: string, limit?: number) =>
  client.get('/ai/tasks', { params: { status, limit } }).then(res => res.data);

export interface AITaskSummary {
  total: number;
  pending: number;
  processing: number;
  completed: number;
  failed: number;
}

export const getAITaskSummary = () =>
  client.get<AITaskSummary>('/ai/tasks/summary').then(res => res.data);

export const getAIQueueStatus = () =>
  client.get('/ai/queue-status').then(res => res.data);

export const cancelAITasks = () =>
  client.post('/ai/tasks/cancel').then(res => res.data);

// Bitmiş logları sil (completed/failed). Bekleyen/işlenen işlere ve
// Bull kuyruğuna dokunmaz — arka plan aynen çalışmaya devam eder.
export const clearAITaskLogs = () =>
  client.delete('/ai/tasks/logs').then(res => res.data);

export const translateProduct = (id: string) =>
  client.post(`/ai/products/${id}/translate`).then(res => res.data);

export const generateProductContent = (id: string) =>
  client.post(`/ai/products/${id}/generate`).then(res => res.data);

export const getProductAIStatus = (id: string) =>
  client.get(`/ai/products/${id}/ai-status`).then(res => res.data);

export const bulkAITranslate = (productIds: string[], taskType = 'both', languageMode: 'en' | 'all' = 'all') =>
  client.post('/ai/products/bulk-ai', { productIds, taskType, languageMode }).then(res => res.data);

export const bulkLuxuryDescribe = (productIds: string[], languageMode: 'en' | 'all' = 'all') =>
  client.post('/ai/products/bulk-ai', { productIds, taskType: 'luxury_description', languageMode }).then(res => res.data);

export const generateDescriptionSync = (title: string, category: string, tags?: string[], language?: string) =>
  client.post('/ai/generate-description', { title, category, tags, language }).then(res => res.data);

export const generateAllDescriptionsSync = (title: string, category: string, tags?: string[]) =>
  client.post('/ai/generate-all-descriptions', { title, category, tags }).then(res => res.data);

export const cleanupDescriptions = (keyword: string, action: 'clear_matching' | 'clear_all') =>
  client.post('/ai/cleanup-descriptions', { keyword, action }).then(res => res.data);
